var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DepartmentAbout',{attrs:{"heading":_vm.data.heading || '',"text":_vm.data.text || '',"stats":_vm.data.stats || []}})}
var staticRenderFns = []

export { render, staticRenderFns }